import { Distretto } from './anagrafica_geo';
import { Professione, TitoloStudio } from './dettaglio_profilo';
import { LinguaSistema } from './lingua_sistema';
import { date2Date, date2string } from './dateStr';
import { HmModelRest } from './abstract_model';
import { Gravidanza } from './gravidanza';

export enum RuoliUtente {
    superadmin = 'superadmin',
    monitor = 'monitor',
    admin = 'admin',
    mes = 'mes',
    medico_generico = 'medico_generico',
    medico_ginecologo = 'medico_ginecologo',
    ostetrica = 'ostetrica',
    user = 'user',
    user_arpa = 'user_arpa',
    operatore = 'operatore',
}

export const RuoliUtenteValues = [
  // { label: 'Superadmin', value: 'superadmin' },
  // { label: 'Admin', value: 'admin' },
  { label: 'Operatore', value: 'operatore' },
  { label: 'Ostetrica', value: 'ostetrica' },
  { label: 'Medico Ginecologo', value: 'medico_ginecologo' },
  { label: 'Medico generico', value: 'medico_generico' },
]
export interface AssocDistrAuth {
    distretto: Distretto;
    autorizzazione: any;
}


export interface AutorizzazioneOperatore {
    denominazione: string;
    cf_medico: string;
    forced: boolean;
    role: RuoliUtente;
    status: string;
    tstamp: Date;
}


export interface AutorizzazioneDistretto {
    distretto: number | Distretto;
    forced: boolean;
    status: string;
    tstamp: Date;
}

export interface DescrizioneMedicoFamiglia {
    tipo_medico: string;
    cf_medico: string;
    denominazione_medico: string;
}


export class Device extends HmModelRest {
    static readonly rest_path = 'devices';

    id: number;
    uuid: string;
    os: string;
    locale: string;
    token: string;
    utente: number | Utente;
}



export class Utente extends HmModelRest {
    static readonly rest_path = 'utenti';

    id: number;
    username: string;
    cod_fiscale: string;
    nome: string;
    cognome: string;
    email: string;
    role: RuoliUtente;
    telefono: string;

    moodle_id: number;
    gcm: boolean;
    autorizza_comunicazioni: boolean;

    data_nascita: Date | string;

    get data_nascita_string(): string {
        if (!this.data_nascita) return null;
        return date2string(this.data_nascita);
    }

    get data_nascita_date(): Date {
      if (!this.data_nascita) return null;
      return date2Date(this.data_nascita)
    }

    luogo_nascita: string;
    professione: number | Professione;
    professione_altro: string;
    titolo_studio: number | TitoloStudio;
    info_app: boolean;

    lingua: string | LinguaSistema;
    consenso_indagine: boolean;

    distretto: number; // | Distretto;
    distretto_domicilio: number; // | Distretto;

    cittadinanza: number;

    indirizzo_domicilio: string;
    comune_domicilio: number;
    nazione_domicilio: number;

    indirizzo_residenza: string;
    comune_residenza: number;
    nazione_residenza: number;


    data_test_immunologico: Date;
    get data_test_immunologico_string(): string {
        if (!this.data_nascita) return null;

        return date2string(this.data_nascita);
    }
    data_esame_clinico: Date;
    get data_esame_clinico_string(): string {
        if (!this.data_nascita) return null;

        return date2string(this.data_nascita);
    }
    data_esame_ecografico: Date;
    get data_esame_ecografico_string(): string {
        if (!this.data_nascita) return null;

        return date2string(this.data_nascita);
    }

    autorizzazione_medici: [AutorizzazioneOperatore];
	/*[{
	  role: string,
	  forced: boolean,
	  status: string,
	  tstamp: string,
	  cf_medico: string,
	  denominazione: string,
	}];*/

    autorizzazione_distretti: [AutorizzazioneDistretto];
	/*
	[{
	  forced: boolean,
	  status: string,
	  tstamp: string,
	  distretto: number,
	}];
	*/

    utente_anonimo: boolean;
}

